<div class="drawer-container">
    <div class="container">
        <div class="actions">
            <div class="actions-left">
                <button iccButton appearance="secondary" (click)="filterUndelivered()" *ngIf="filtered">
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Wszystkie' | translate }}
                </button>
                <button iccButton appearance="secondary" (click)="filterUndelivered()" *ngIf="!filtered">
                    <icc-icon name="search"></icc-icon>
                    {{ 'DELIVERY|Do dostarczenia' | translate }}
                </button>
            </div>
            <div class="actions-right">
                <button class="action-button-refresh" iccIconButton appearance="flat-base" (click)="updateList(true)" [title]="'INTERFACE|Odśwież' | translate">
                    <icc-icon name="replay"></icc-icon>
                </button>
            </div>
        </div>

        <div class="table-container">
            <table class="documents-table">
                <thead>
                    <tr>
                        <th><span translate>DELIVERY|Dane dostawy</span></th>
                        <th>
                            <span translate>INTERFACE|Data utworzenia</span>
                            <span translate>INTERFACE|Data modyfikacji</span>
                        </th>
                        <th><span translate>DELIVERY|Dostarczone</span></th>
                        <th *ngIf="!mobileView" translate>INTERFACE|Opcje</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let document of allDeliveries  | paginate: { itemsPerPage: documentsInPage, currentPage: page, totalItems: totalItems };trackBy:trackByUuid">
                        <tr>
                            <td class="documents-table__name" (click)="open(document)">
                                <b>{{ document?.client }}</b><br>
                                <span>{{ document?.deliveryAddress }}</span>
                            </td>
                            <td class="documents-table__date" (click)="open(document)" >
                                {{ document?.created | date : 'medium' }}<br>
                                {{ document?.modified | date : 'medium' }}
                            </td>
                            <td class="documents-table__status" (click)="open(document)">
                                <span *ngIf="document?.isConfirmed" translate>INTERFACE|Tak</span>
                                <span *ngIf="!document?.isConfirmed" translate>INTERFACE|Nie</span>
                            </td>
                            <td *ngIf="!mobileView">
                                <div class="documents-table__options">
                                    <button iccButton appearance="secondary"  (click)="open(document)">
                                        {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <pagination-controls
            (pageChange)="onChangePage($event)"
            [previousLabel]="'INTERFACE|Poprzednia' | translate"
            [nextLabel]="'INTERFACE|Następna' | translate"
            maxSize="6"
        ></pagination-controls>
    </div>
</div>